const actions = {
  SET_LISTING_PERFORMANCE_TABLE_DATA: 'SET_LISTING_PERFORMANCE_TABLE_DATA',
  SET_OLX_LISTING_PERFORMANCE_TABLE_DATA: 'SET_OLX_LISTING_PERFORMANCE_TABLE_DATA',
};

export default actions;
